var map = {
	"./Docker_colour.svg": 68,
	"./Salesforce_name.svg": 69,
	"./analyze.svg": 70,
	"./build.svg": 71,
	"./define.svg": 72,
	"./docker.svg": 73,
	"./docker_full.svg": 74,
	"./google.svg": 75,
	"./ideate.svg": 76,
	"./integration.svg": 77,
	"./logo-black.svg": 27,
	"./logo-dot-white.svg": 78,
	"./logo-full-white.svg": 79,
	"./logo-white.svg": 32,
	"./logo_transparent.png": 80,
	"./phone.svg": 81,
	"./prototype.svg": 82,
	"./salesforce.svg": 83,
	"./salesforce_colour.svg": 84,
	"./salesforce_round.png": 85,
	"./seminar.svg": 86,
	"./teacher.svg": 87,
	"./technical-support.svg": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;